import set from 'transmute/set';
export const setGlobalCookieOptOut = set('globalCookieOptOut');